import { CategoryData, PageMappingData, PlanData, PlanPageMapping } from "types/models/planMaster/planMasterApp";


// Plan Constants 
export const GET_Plan = "GET_Plan";
export const SET_Plan_DATA = "SET_Plan_DATA";
export const CREATE_PLAN = "CREATE_PLAN";
export const UPDATE_PLAN = "UPDATE_PLAN";
export const DELETE_PLAN = "DELETE_PLAN";
export const CREATE_PLAN_GROUP = "CREATE_PLAN_GROUP"


export const CREATE_PLAN_PAGE="CREATE_PLAN_PAGE";
 export const GET_PAGE_Plan = "GET_PAGE_PLAN"
 export const DELETE_PAGE_Plan = "DELETE_PAGE_PLAN"


// Category Constants 
export const GET_Category = "GET_Category";
export const SET_Category_DATA = "SET_Category_DATA";
// PageMapping Constants 
export const GET_PageMapping = "GET_PageMapping";
export const SET_PageMapping_DATA = "SET_PageMapping_DATA";
export const Plans_Count_Dashboard = "Plans_Count_Dashboard";
// Plan Action Interfaces 
export interface GetPlanAction {
  type: typeof GET_Plan;
  payload: { rows: PlanData[]; count: number };
}
export interface GetPagePlanAction {
  type: typeof GET_PAGE_Plan;
  payload: { data: PlanData[]; };
}
export interface SetPlanDetailAction {
  type: typeof SET_Plan_DATA;
  payload: PlanData;
}
export interface createPlan{
  type: typeof CREATE_PLAN;
    payload: any; 
}
export interface createPlanGroup{
  type:typeof CREATE_PLAN_GROUP;
  payload:any;
}
export interface updatePlan{
  type: typeof UPDATE_PLAN;
  payload:any;
}

export interface DeletePlan{
  type: typeof DELETE_PLAN;
  payload: any;
}
export interface DeletePlanPage{
  type: typeof DELETE_PAGE_Plan;
  payload: any;
}

// Category Action Interfaces 
export interface GetCategoryAction {
  type: typeof GET_Category;
  payload: { category: CategoryData[]; categoryCount: number };
}

export interface SetCategoryDetailAction {
  type: typeof SET_Category_DATA;
  payload: CategoryData;
}
// PageMapping Action Interfaces 
export interface GetPageMappingAction {
  type: typeof GET_PageMapping;
  payload: { pageMapping: PageMappingData[]; pageMappingCount: number };
}

export interface SetPageMappingDetailAction {
  type: typeof SET_PageMapping_DATA;
  payload: PlanPageMapping;
}

export interface createPlanPage{
  type: typeof CREATE_PLAN_PAGE;
    payload: any; 
}
export interface PlansCountDashboardAction {
  type: typeof Plans_Count_Dashboard;
  payload: any;
}
export type PlanMasterActionTypes =
  | GetPlanAction
  |GetPagePlanAction
  | SetPlanDetailAction
  | updatePlan
  | createPlan
  | createPlanGroup
  | GetCategoryAction 
  | SetCategoryDetailAction
  | GetPageMappingAction
  | SetPageMappingDetailAction
  |updatePlan
  |createPlanPage
  |DeletePlan
  |DeletePlanPage
  |PlansCountDashboardAction

